<template>
    <button>
        <span>
            <slot />
        </span>
        
        <Spinner 
            v-if="loading"
            
            :width-class="widthClass" 
        />
    </button>
</template>

<script>
import Spinner from '@app/components/loading/Spinner.vue';

export default {
    components: { Spinner },
    props: {
        loading    : Boolean,
        widthClass : {
            type    : String,
            default : 'w-[32px]'
        }
    },
}
</script>